import React from "react";
import { AllImages } from "../../Assets/Images/AllImages";
import CardComponent from "../CardComponent/CardComponent";
import Container from "react-bootstrap/Container";
import "./ContainerComponent.scss";
const ContainerComponent = (props) => {
  return (
    <Container className="container-component-container">
      <div className="container-title">{props?.containerTitle}</div>
      <div className="container-sub-title mb-5">{props?.subTitle}</div>
      <div className="container-component-main">{props?.children}</div>
      <hr></hr>
    </Container>
  );
};

export default ContainerComponent;
